import React from 'react'

import './Footer.css'

const Footer = () => (
  <footer id='Footer'>
    ©2018 Roxana Núñez Trabucco
  </footer>
)


export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js